import { environment } from '@environments/environment';

const { websiteUrl } = environment;

export const ExternalLinks: { [key in string]: string } = {
  FAQ: `${websiteUrl}/faqs/`,
  PRIVACY_POLICY: `${websiteUrl}/privacy-policy/`,
  TERMS_AND_CONDITIONS: `${websiteUrl}/terms-and-condition/`,
};
